// assets/product-gallery.js
// Two responsibilities:
// 1) PDP gallery (data-pr-gallery) — thumb click + keyboard swap main image, with prev/next arrows
// 2) Product card thumbs (data-prod-card) — thumb click swap card hero image
(function () {
  const swapWidth = (src, w) => {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/(\?|&)width=\d+/, (m, sep) => sep + 'width=' + w);
    }
    return src + (src.includes('?') ? '&' : '?') + 'width=' + w;
  };

  // ---------- PDP gallery ----------
  document.querySelectorAll('[data-pr-gallery]').forEach((gallery) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const main = gallery.querySelector('[data-main-image]');
    if (!main || thumbs.length === 0) return;
    const mainImg = main.querySelector('img');
    if (!mainImg) return;

    let currentIndex = 0;
    const activate = (idx) => {
      const thumb = thumbs[idx];
      if (!thumb) return;
      const img = thumb.querySelector('img');
      if (!img) return;
      const newSrc = img.getAttribute('src');
      const newAlt = img.getAttribute('alt') || '';
      mainImg.setAttribute('src', swapWidth(newSrc, 1200));
      mainImg.removeAttribute('srcset');
      mainImg.setAttribute('alt', newAlt);
      thumbs.forEach((t, i) => t.classList.toggle('pr-thumb--active', i === idx));
      currentIndex = idx;
    };

    thumbs.forEach((thumb, idx) => {
      thumb.addEventListener('click', (e) => { e.preventDefault(); activate(idx); });
      thumb.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(idx); }
      });
    });

    // Prev/Next arrows
    if (thumbs.length > 1) {
      const prev = document.createElement('button');
      prev.className = 'pr-main-img__nav pr-main-img__nav--prev';
      prev.setAttribute('aria-label', 'Imagem anterior');
      prev.innerHTML = '<span aria-hidden="true">‹</span>';
      const next = document.createElement('button');
      next.className = 'pr-main-img__nav pr-main-img__nav--next';
      next.setAttribute('aria-label', 'Próxima imagem');
      next.innerHTML = '<span aria-hidden="true">›</span>';
      main.appendChild(prev);
      main.appendChild(next);
      prev.addEventListener('click', () => activate((currentIndex - 1 + thumbs.length) % thumbs.length));
      next.addEventListener('click', () => activate((currentIndex + 1) % thumbs.length));

      // Arrow key navigation when gallery is focused
      gallery.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); activate((currentIndex - 1 + thumbs.length) % thumbs.length); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); activate((currentIndex + 1) % thumbs.length); }
      });
    }
  });

  // ---------- Card product thumbs ----------
  document.querySelectorAll('[data-prod-card]').forEach((card) => {
    const thumbs = Array.from(card.querySelectorAll('[data-prod-card-thumb]'));
    const mainContainer = card.querySelector('[data-prod-card-main]');
    if (!mainContainer || thumbs.length === 0) return;
    const mainImg = mainContainer.querySelector('img');
    if (!mainImg) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const img = thumb.querySelector('img');
        if (!img) return;
        const newSrc = img.getAttribute('src');
        const newAlt = img.getAttribute('alt') || '';
        mainImg.setAttribute('src', swapWidth(newSrc, 800));
        mainImg.removeAttribute('srcset');
        mainImg.setAttribute('alt', newAlt);
        thumbs.forEach((t) => t.classList.toggle('prod-card__thumb--active', t === thumb));
      });
    });
  });
})();
